import React, {useContext, useEffect, useRef, useState} from "react";
import {NavLink} from "react-router-dom";
import {Container, Offcanvas} from "react-bootstrap";
import MainMenu from "./MainMenu";
import {AuthContext} from "../context/authContext";
import ProviderUserMenuItems from "./ProviderLayout/ProviderUserMenuItems";
import ClientUserMenuItems from "./ClientLayout/ClientUserMenuItems";
import logoImage from "../assets/small_logo.png";

const Header = ({ relatedTop = 95 }) => {
  const [show, setShow] = useState(false);
  const { user } = useContext(AuthContext)
  const svgRef = useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setTimeout(() => {
      document.querySelectorAll('.close-nav').forEach(item => {
        item.addEventListener('click', () => {
          handleClose()
        })
      })
    }, 100)
  }

  useEffect(() => {
    const handleResize = () => {
      const svgEl = svgRef.current;
      if (svgEl) {
        const rect = svgEl.getBoundingClientRect();
        const height = rect.height;

        const svgTop = relatedTop - (height / 10 * 3)
        svgEl.style.top = `${svgTop}px`;

        const leftHeight = relatedTop + height / 100;
        document.getElementById('left-gradient').style.height = `${leftHeight}px`;

        const rightHeight = relatedTop + height * 57 / 100;
        document.getElementById('right-gradient').style.height = `${rightHeight}px`;
        svgEl.classList.add('container');
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize()
    handleResize()
    return () => window.removeEventListener('resize', handleResize);
  }, [relatedTop, svgRef]);


  return (
    <>
      <div className="header-container">
        <div className="border-bottom shadow z-1 position-fixed w-100 top-0 bg-white">
          <Container className="py-1">
            <nav className="navbar navbar-expand-md rounded d-none d-md-flex p-0" aria-label="Offcanvas navbar large"
                 id="header">
              <MainMenu />
            </nav>
            <nav className="navbar navbar-expand-md rounded p-0" aria-label="Offcanvas navbar large" id="header">
              <NavLink to='/' className="navbar-brand d-md-none d-md-flex" href="#">
                <img src={logoImage} width="50px" alt="logo" />
              </NavLink>
              <div className='text-end'>
                <button className="navbar-toggler" type="button" onClick={handleShow}>
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>
              <Offcanvas className="shadow"
                         as="div"
                         placement='end'
                         show={show}
                         onHide={handleClose}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>MeniuM</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <MainMenu excludeUserMenu={true} />
                  <hr />
                  <nav className="navbar navbar-expand-md rounded ms-3" aria-label="Offcanvas navbar large" id="header">
                    <ul className="navbar-nav col-md-6 justify-content-md-center">
                      {user && user.type === 'provider' && <ProviderUserMenuItems />}
                      {user && user.type === 'client' && <ClientUserMenuItems />}
                    </ul>
                  </nav>
                  {user && <hr />}
                </Offcanvas.Body>
              </Offcanvas>
            </nav>
          </Container>
        </div>
      </div>
      <Container>
        <div className="green-gradient">
          <div id="left-gradient"></div>
          <svg viewBox="0 0 1843 200" xmlns="http://www.w3.org/2000/svg" className="" id="wave" ref={svgRef}>
            <path fill="rgba(153, 217, 186, 1)" d="M 0 61 C 467 61 467 133 934 133 L 934 133 L 934 0 L 0 0 Z"
                  strokeWidth="0"></path>
            <path fill="rgba(153, 217, 186, 1)" d="M 933 133 C 1388 133 1388 174 1843 174 L 1843 174 L 1843 0 L 933 0 Z"
                  strokeWidth="0"></path>
          </svg>
          <div id="right-gradient"></div>
        </div>
      </Container>

    </>
  )
}

export default Header
